import * as React from "react";
import { forwardRef } from "react";
const SvgGiftback = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M19.0435 12.3711V18.1624C19.0435 18.5037 18.9079 18.8311 18.6665 19.0724C18.4252 19.3138 18.0978 19.4494 17.7565 19.4494H6.24301C5.90169 19.4494 5.57435 19.3138 5.333 19.0724C5.09164 18.8311 4.95605 18.5037 4.95605 18.1624V12.3711",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.5 8.16022C12.5 8.16022 13.7689 5.57732 14.9519 4.89338C16.2925 4.11834 17.4314 5.54624 16.4254 6.42105C15.4027 7.31027 12.5 8.16022 12.5 8.16022Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.5 8.16022C11.5 8.16022 10.2311 5.57732 9.04811 4.89338C7.70751 4.11834 6.56855 5.54624 7.57462 6.42105C8.59726 7.31027 11.5 8.16022 11.5 8.16022Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 10.084,
	y: 12.3711,
	width: 3.71582,
	height: 7.07837,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 10.084,
	y: 8.16016,
	width: 3.71582,
	height: 4.21094,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 3.8291,
	y: 8.16016,
	width: 16.3428,
	height: 4.21094,
	rx: 1,
	stroke: "currentColor",
	strokeWidth: 1.5
}));
const ForwardRef = forwardRef(SvgGiftback);
export default ForwardRef;
